import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { Common, Custom, FormSignIn } from "components";
import { useApp, useParameter, useTheme } from "contexts";
import { Helpers, Routes } from "utils";
import { useNavigate } from "react-router-dom";
import { Combines } from "helpers";
import { AuthParamType } from "types";

type Props = {};

export const SignIn = (props: Props) => {
  const navigate = useNavigate();

  const { t } = useApp();
  const { theme } = useTheme();
  const { token, params } = useParameter<AuthParamType>();

  const handleOnboarding = () =>
    navigate(Combines.interpolateURL(Routes.useronboarding, { token: token }));

  const handleGuestOnboarding = () => {
    navigate(
      Combines.interpolateURL(Routes.userguestonboarding, {
        token: token,
      })
    );
  };

  const handleForgotPassword = () =>
    navigate(Combines.interpolateURL(Routes.forgotpassword, { token: token }));
  const handleAccountRecovery = () =>
    navigate(Combines.interpolateURL(Routes.accountrecovery, { token: token }));

  return (
    <Box pt={theme.spacing.xl}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Box>
                <Stack spacing={theme.spacing.sm}>
                  <Common.Image src={Helpers.getImage("homepage_banner.png")} />
                  <Box
                    sx={{
                      border: 1,
                      overflow: "hidden",
                      mt: theme.spacing.md,
                      pt: theme.spacing.lg,
                      px: theme.spacing.lg,
                      pb: theme.spacing.xxl,
                      borderRadius: theme.border.radius,
                      borderColor: theme.color.primary.accent,
                    }}
                  >
                    <Stack spacing={theme.spacing.sm}>
                      <Stack spacing={theme.spacing.md}>
                        <Custom.Typography
                          size={theme.font.lg}
                          weight={theme.font.bold}
                        >
                          {t.page.sign_in.header}
                        </Custom.Typography>
                        <Custom.Typography
                          size={theme.font.sm}
                          weight={theme.font.bold}
                        >
                          {t.page.sign_in.subheader}
                        </Custom.Typography>
                      </Stack>
                      <FormSignIn.Form
                        email={params.email}
                        redirect={params.redirect}
                      />
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        spacing={theme.spacing.xs}
                      >
                        <Custom.Button
                          size="small"
                          onClick={handleForgotPassword}
                        >
                          {t.action.forgot_password}
                        </Custom.Button>
                        <Custom.Typography align="center" size={theme.font.sm}>
                          {t.conjunction.or}
                        </Custom.Typography>{" "}
                        <Custom.Button size="small" onClick={handleOnboarding}>
                          {t.action.sign_up}
                        </Custom.Button>
                      </Stack>
                    </Stack>

                    <Common.Divider sx={{ mx: -theme.spacing.lg }} />

                    <Custom.Button
                      fullWidth
                      variant="outlined"
                      trailing="right"
                      sx={{ mt: theme.spacing.md }}
                      onClick={handleAccountRecovery}
                    >
                      {t.button.sign_in_guest}
                    </Custom.Button>
                  </Box>
                </Stack>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{ display: { sm: "none", md: "unset" } }}
            >
              <Common.Image src={Helpers.getImage("homepage_art.png")} />
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </Box>
  );
};
